import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type MentionWithSuggestedCorrection = WithLegacy<{
  mentionId: string | null;
  itemName: string | null;
  extractedName: string | null;
  correctedName: string | null;
  mentionType: string | null;
  externalSource: string | null;
  externalId: string | null;
  contentSourceId: string | null;
  [Type]: 'mention-with-suggested-correction';
}>;

export const MentionWithSuggestedCorrectionSchema = withDefaults({
  type: 'mention-with-suggested-correction',
  fields: [
    { name: 'mentionId', kind: 'attribute', type: 'string' },
    { name: 'itemName', kind: 'attribute', type: 'string' },
    { name: 'extractedName', kind: 'attribute', type: 'string' },
    { name: 'correctedName', kind: 'attribute', type: 'string' },
    { name: 'mentionType', kind: 'attribute', type: 'string' },
    { name: 'externalSource', kind: 'attribute', type: 'string' },
    { name: 'externalId', kind: 'attribute', type: 'string' },
    { name: 'contentSourceId', kind: 'attribute', type: 'string' },
  ],
});
